import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-headlease-list-page',
    templateUrl: './headlease-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeadleaseListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Head Leases');
  }

  handleRowSelect(data) {
    this.router.navigate([`/entity-data/property/${data['SystemHeadLeasePropertyRef']}/headlease/${data['SystemHeadLeaseRef']}`]);
  }

  getRowHref = (row) => {
    return `/entity-data/property/${row['SystemHeadLeasePropertyRef']}/headlease/${row['SystemHeadLeaseRef']}`;
  }
}
